/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License").
 *  You may not use this file except in compliance with the License.
 *  A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 *  or in the "license" file accompanying this file. This file is distributed
 *  on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 *  express or implied. See the License for the specific language governing
 *  permissions and limitations under the License.
 */

/* eslint-disable import/prefer-default-export */
import { types } from 'mobx-state-tree';
import { BaseStore } from '@amzn/base-ui/dist/models/BaseStore';

import { getCatalogueProductDetails } from '../../helpers/api';

// ==================================================================
// CatalogueProductDetailStore
// ==================================================================
const CatalogueProductDetailStore = BaseStore.named('CatalogueProductDetailStore')
  .props({
    productId: '',
    provisioningArtifacts: types.frozen([]),
    provisioningParameters: types.frozen([]),
    launchPaths: types.frozen([]),
  })

  .actions(self => {
    // save the base implementation of cleanup
    const superCleanup = self.cleanup;

    return {
      async doLoad(region) {
        const details = await getCatalogueProductDetails(self.productId, region);
        self.runInAction(() => {
          self.provisioningArtifacts = details.provisioningArtifacts || [];
          self.provisioningParameters = details.provisioningParameters || [];
          self.launchPaths = details.launchPaths || [];
        });
      },

      cleanup: () => {
        self.provisioningArtifacts = [];
        self.provisioningParameters = [];
        self.launchPaths = [];
        superCleanup();
      },
    };
  });

// Note: Do NOT register this in the global context, if you want to gain access to an instance
//       use catalogueProductsStore.getDetailStore()
export { CatalogueProductDetailStore };
